module.exports = __webpack_public_path__ + "img/28_11.dc7bff80.png";